<script>
import userApi from '@/api/user';
import contactApi from '@/api/contact';
import referralApi from '@/api/referral';
import payoutApi from '@/api/payout';
import userStatisticApi from '@/api/userStatistics';

import DefaultLayout from '@/layouts/Default.vue';
import UserDetailLayout from '@/components/user/UserDetailLayout.vue';
import AdminUserDetailPopup from '@/components/admin/AdminUserDetailPopup.vue';

export default {
  name: 'UserAdminDetailPage',
  components: { DefaultLayout, UserDetailLayout, AdminUserDetailPopup },
  data() {
    return {
      user: null,
      additionalInfo: {
        tasks: [],
        projects: [],
        contacts: [],
        referrals: [],
        payouts: [],
        userStatistics: {},
      },
      isPopUpShown: false,
      popupConfig: null,
      isLoaded: false,
    };
  },
  mounted() {
    this.fetchUser();
  },
  computed: {
    popupConfigs() {
      return {
        accountBalance: { label: 'Пополнить счёт', fieldName: 'accountBalance', currentValue: this.user.accountBalance },
      };
    },
  },
  methods: {
    async fetchUser() {
      this.isLoaded = false;
      const routeId = this.$route.params.userId;

      this.user = await userApi.fetchItem(routeId, {}, true);
      await this.fetchAdditionalInfo(routeId);

      this.isLoaded = true;
    },

    async fetchAdditionalInfo(routeId) {
      const contacts = [contactApi.fetchList({ isAdmin: true, author: routeId }, true), contactApi.fetchList({ isAdmin: true, acceptor: routeId }, true)];
      const referrals = [referralApi.fetchList({ isAdmin: true, referral: routeId }, true), referralApi.fetchList({ isAdmin: true, affiliate: routeId }, true)];
      const payouts = [payoutApi.fetchList({ isAdmin: true, owner: routeId }, true), payoutApi.fetchList({ isAdmin: true, targetUser: routeId }, true)];
      const projectQTY = userStatisticApi.fetchList({ isAdmin: true, user: routeId, type: 'PROJECT_QTY' }, true);
      const membershipQTY = userStatisticApi.fetchList({ isAdmin: true, user: routeId, type: 'MEMBERSHIP_QTY' }, true);
      const storage = userStatisticApi.fetchList({ isAdmin: true, user: routeId, type: 'STORAGE' }, true);

      const promises = [...contacts, ...referrals, ...payouts, projectQTY, membershipQTY, storage];
      const requests = await Promise.all(promises);
      const responses = requests.map(request => request.items);

      this.additionalInfo.contacts = responses.splice(0, contacts.length).reduce((acc, value) => [...acc, ...value], []);
      this.additionalInfo.referrals = responses.splice(0, referrals.length).reduce((acc, value) => [...acc, ...value], []);
      this.additionalInfo.payouts = responses.splice(0, payouts.length).reduce((acc, value) => [...acc, ...value], []);
      this.additionalInfo.userStatistics = { projects: responses[0], membership: responses[1], storage: responses[2] };
    },

    async onUpdate(event) {
      const eventToUpdate = { ...event };

      if (event.tariff) {
        eventToUpdate.tariff = event.tariff['@id'];
      }

      if (event.phone === '') {
        eventToUpdate.phone = null;
      }

      try {
        await userApi.update(this.user.id, eventToUpdate, true);
      } catch (e) {
        this.$alert('При сохранении произошла ошибка');
        return;
      }
      this.closePopup();
      await this.fetchUser();
      this.$push({ text: 'Изменения сохранены' });
    },

    showPopup(event) {
      this.popupConfig = this.popupConfigs[event];
      this.isPopUpShown = true;
    },

    closePopup() {
      this.isPopUpShown = false;
      this.popupConfig = null;
    },

    async deleteContact(event) {
      const question = 'Вы действительно хотите удалить контакт?';
      const result = await this.$confirm(question);

      if (result) {
        await contactApi.delete(event);
        await this.fetchUser();
        this.$push({ text: 'Контакт успешно удалён' });
      }
    },

    async deleteAccount(event) {
      const question = 'Вы действительно хотите удалить контакт?';
      const result = await this.$confirm(question);

      if (result) {
        await userApi.delete(event);
        await this.$router.push({ name: 'admin-users' });
      }
    },

    async onAvatarChanged(avatar) {
      const avatarChanged = await userApi.update(this.user.id, avatar, true);
      if (avatarChanged) {
        await this.fetchUser();
        this.$push({ text: 'Аватар изменён' });
      }
    },
  },
};
</script>

<template lang="pug">
DefaultLayout(v-if="isLoaded")
  AdminUserDetailPopup(v-if="isPopUpShown && popupConfig" :config="popupConfig" @close="closePopup" @update="onUpdate")
  UserDetailLayout(
    :user="user"
    :additionalInfo="additionalInfo"
    :tab="$route.params.tab"
    :isAdmin="true"
    @update="onUpdate"
    @onAvatarChanged="onAvatarChanged"
    @changeTab="$router.push({ params: { tab: $event } })"
    @goToTariffs="$router.push({ name: $event })"
    @showPopup="showPopup"
    @deleteContact="deleteContact"
    @deleteAccount="deleteAccount")
</template>

<style scoped lang="scss">
</style>
